import { apiClient, type ApiResponse } from '@/api';
import { HELP_API_URLS } from '@/api/constants/api.url';
import { EMPTY_HELP, type HelpContent, type HelpKind } from '@/shared/help/types';

/** Tolerate a partial payload rather than crashing the panel on a shape change. */
function normalize(data: Partial<HelpContent> | undefined): HelpContent {
    return {
        articles: data?.articles ?? EMPTY_HELP.articles,
        videos:   data?.videos   ?? EMPTY_HELP.videos,
        news:     data?.news     ?? EMPTY_HELP.news,
    };
}

export const helpService = {
    /** Admin view — includes hidden entries. */
    async listAll(): Promise<HelpContent> {
        const { data } = await apiClient.get<ApiResponse<HelpContent>>(HELP_API_URLS.admin);
        return normalize(data.data);
    },

    /** Client view — published entries only. */
    async listPublished(): Promise<HelpContent> {
        const { data } = await apiClient.get<ApiResponse<HelpContent>>(HELP_API_URLS.published);
        return normalize(data.data);
    },

    async create(kind: HelpKind, body: Record<string, unknown>): Promise<void> {
        await apiClient.post(HELP_API_URLS.create(kind), body);
    },

    async update(kind: HelpKind, id: string, body: Record<string, unknown>): Promise<void> {
        await apiClient.patch(HELP_API_URLS.entry(kind, id), body);
    },

    async remove(kind: HelpKind, id: string): Promise<void> {
        await apiClient.delete(HELP_API_URLS.entry(kind, id));
    },
};
